var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "logo", attrs: { "data-v-77c14c32": "" } }, [
      _c(
        "div",
        { staticClass: "p-w30 pull-left", attrs: { "data-v-77c14c32": "" } },
        [
          _c("a", { attrs: { "data-v-77c14c32": "", href: "#" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "32px",
                  "font-weight": "bold",
                  color: "rgb(50, 80, 250)"
                },
                attrs: { "data-v-77c14c32": "" }
              },
              [_vm._v(_vm._s(_vm.title) + "\n            ")]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info-container" },
      [
        _c("mt-field", {
          attrs: { placeholder: "邮箱或手机号", type: "text" },
          on: { paste: _vm.paste },
          model: {
            value: _vm.info.account,
            callback: function($$v) {
              _vm.$set(_vm.info, "account", $$v)
            },
            expression: "info.account"
          }
        }),
        _vm._v(" "),
        _c("mt-field", {
          attrs: { placeholder: "密码", type: "password" },
          model: {
            value: _vm.info.password,
            callback: function($$v) {
              _vm.$set(_vm.info, "password", $$v)
            },
            expression: "info.password"
          }
        }),
        _vm._v(" "),
        _vm.failedCount >= 15
          ? _c(
              "mt-field",
              {
                attrs: { placeholder: "验证码", type: "text" },
                model: {
                  value: _vm.info.validCode,
                  callback: function($$v) {
                    _vm.$set(_vm.info, "validCode", $$v)
                  },
                  expression: "info.validCode"
                }
              },
              [
                _c("div", {
                  staticClass: "valid-code",
                  style: {
                    "background-image": "url(" + _vm.validCodeUrl + ")"
                  },
                  on: { click: _vm.getValidCode }
                })
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.popupVisible,
            expression: "!popupVisible"
          }
        ],
        staticClass: "sc-box"
      },
      [_c("div", { attrs: { id: "sc" } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-button-group my-6 px-2" },
      [
        _c(
          "mt-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.popupVisible,
                expression: "popupVisible"
              }
            ],
            staticClass: "bg-blue",
            attrs: { size: "large", type: "primary" },
            on: { click: _vm.login }
          },
          [_vm._v("登录")]
        ),
        _vm._v(" "),
        _c(
          "mt-button",
          {
            staticClass: "bg-dark-blue",
            attrs: { size: "large", type: "primary" },
            on: { click: _vm.register }
          },
          [_vm._v("注册")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "login-tip" }, [
      _c(
        "span",
        { staticClass: "color-gray", on: { click: _vm.forgetPassword } },
        [_vm._v("忘记密码？")]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "color-gray pl-2", on: { click: _vm.goHomePage } },
        [_vm._v("暂不登录")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77c14c32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77c14c32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/login/login.vue
// module id = null
// module chunks = 